import FieldRender from './field';


const contextForUiGen = (obj) => {
  const context = {
    isInvalid: obj.isInvalid,
    isValid: obj.isValid,
    ...obj.uiProps,
  };

  return context;
};

export default {
  name: 'FieldsetRender',

  functional: true,

  components: {
    FieldRender,
  },

  props: {
    fieldset: {
      type: Object,
      required: true,
    },

    canEditValues: {
      type: Boolean,
      required: true,
    },
  },

  render(h, context) {
    const { fieldset } = context.props;

    const {
      canEditValues,
    } = context.props;

    let fieldsetsRenders = fieldset.fields.map((field) => {
      const scopedSlotDefault = field.component.$scopedSlots.default;

      return h(
        FieldRender,
        {
          key: field.id,
          props: {
            field,
            canEditValue: canEditValues,
          },
          scopedSlots: {
            default: scopedSlotDefault,
          },
        },
      );
    });

    if (fieldsetsRenders.length <= 0) {
      fieldsetsRenders = [fieldset.component.$slots.default];
    }

    const contextForUi = contextForUiGen(fieldset);

    const mainUi = h(
      fieldset.component.ui,
      {
        tag: 'component',
        attrs: contextForUi,
      },
      [
        fieldsetsRenders,
      ],
    );

    return mainUi;
  },

  computed: {
    fields() {
      return this.fieldset.fields;
    },
  },
};
